module.exports = __webpack_public_path__ + "img/0.3ab606a9.png";